import {
  Card,
  Col,
  Row,
  // Carousel,
  // Col,
  // Container,
  // ListGroup,
  // Nav,
  // Row,
  // Tab,
  // Tabs,
} from "react-bootstrap";
import "react-circular-progressbar/dist/styles.css";

import DesktopSliderComponent from "../Sliders/DesktopSliderComponent";
import MobileSliderComponent from "../Sliders/MobileSliderComponent";
// import CalencarComponent from "./calendar/CalencarComponent";
// import CalendarWidget from "../Calendar/CalendarWidget";
// import UserInfoComponent from "./UserInfoComponent";
import FaqWidget from "./FaqWidget";
import EmployeeShowcase from "../EmployeeShowcase";
import MessageCenter from "../MessageCenter";
import NewsShowcase from "../NewsShowcase";
import LibraryWidget from "./LibraryWidget";
import ApplicationsShowcase from "../ApplicationsShowcase";
import { t } from "i18next";
import EventCenter from "../EventCenter";

function ServicesComponent({ ...props }) {
  // const percentage = 50;
  // const user = app.user || { displayName: "", jobTitle: "" };

  return (
    <>
      <DesktopSliderComponent className="mb-4" slides={props.data.data} />
      <MobileSliderComponent className="mb-4" slides={props.data.data} />

      <Row className="mb-4 d-flex align-items-stretch">
        <Col md={9} className="d-flex flex-column">
          <div className="content-wrapper flex-grow-1">
            <MessageCenter />
          </div>
        </Col>
        <Col md={3} className="d-flex flex-column">
          <div className="content-wrapper flex-grow-1">
            <EventCenter />
          </div>
        </Col>
      </Row>

      <NewsShowcase limit={6} />

      {/* <Card className="mb-4">
        <Card.Header>{t("library_widget.header")}</Card.Header>
        <Card.Body>
          <LibraryWidget />
        </Card.Body>
      </Card> */}
      <br />

      <ApplicationsShowcase />
    </>
  );
}

export default ServicesComponent;
